import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module image/imageinsert/ui/imageinserturlview
 */
import { icons } from 'ckeditor5/src/core.js';
import { ButtonView, View, ViewCollection, FocusCycler, LabeledFieldView, createLabeledInputText } from 'ckeditor5/src/ui.js';
import { FocusTracker, KeystrokeHandler } from 'ckeditor5/src/utils.js';
/**
 * The insert an image via URL view.
 *
 * See {@link module:image/imageinsert/imageinsertviaurlui~ImageInsertViaUrlUI}.
 */
var ImageInsertUrlView = /*#__PURE__*/function (_View) {
  _inherits(ImageInsertUrlView, _View);
  var _super = _createSuper(ImageInsertUrlView);
  /**
   * Creates a view for the dropdown panel of {@link module:image/imageinsert/imageinsertui~ImageInsertUI}.
   *
   * @param locale The localization services instance.
   */
  function ImageInsertUrlView(locale) {
    var _this;
    _classCallCheck(this, ImageInsertUrlView);
    _this = _super.call(this, locale);
    _this.set('imageURLInputValue', '');
    _this.set('isImageSelected', false);
    _this.set('isEnabled', true);
    _this.focusTracker = new FocusTracker();
    _this.keystrokes = new KeystrokeHandler();
    _this._focusables = new ViewCollection();
    _this.focusCycler = new FocusCycler({
      focusables: _this._focusables,
      focusTracker: _this.focusTracker,
      keystrokeHandler: _this.keystrokes,
      actions: {
        // Navigate form fields backwards using the Shift + Tab keystroke.
        focusPrevious: 'shift + tab',
        // Navigate form fields forwards using the Tab key.
        focusNext: 'tab'
      }
    });
    _this.urlInputView = _this._createUrlInputView();
    _this.insertButtonView = _this._createInsertButton();
    _this.cancelButtonView = _this._createCancelButton();
    _this._focusables.addMany([_this.urlInputView, _this.insertButtonView, _this.cancelButtonView]);
    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-image-insert-url']
      },
      children: [_this.urlInputView, {
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-image-insert-url__action-row']
        },
        children: [_this.insertButtonView, _this.cancelButtonView]
      }]
    });
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(ImageInsertUrlView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(ImageInsertUrlView.prototype), "render", this).call(this);
      var _iterator = _createForOfIteratorHelper(this._focusables),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var view = _step.value;
          this.focusTracker.add(view.element);
        }
        // Start listening for the keystrokes coming from #element.
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.keystrokes.listenTo(this.element);
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(ImageInsertUrlView.prototype), "destroy", this).call(this);
      this.focusTracker.destroy();
      this.keystrokes.destroy();
    }
    /**
     * Creates the {@link #urlInputView}.
     */
  }, {
    key: "_createUrlInputView",
    value: function _createUrlInputView() {
      var _this2 = this;
      var locale = this.locale;
      var t = locale.t;
      var urlInputView = new LabeledFieldView(locale, createLabeledInputText);
      urlInputView.bind('label').to(this, 'isImageSelected', function (value) {
        return value ? t('Update image URL') : t('Insert image via URL');
      });
      urlInputView.bind('isEnabled').to(this);
      urlInputView.fieldView.placeholder = 'https://example.com/image.png';
      urlInputView.fieldView.bind('value').to(this, 'imageURLInputValue', function (value) {
        return value || '';
      });
      urlInputView.fieldView.on('input', function () {
        _this2.imageURLInputValue = urlInputView.fieldView.element.value.trim();
      });
      return urlInputView;
    }
    /**
     * Creates the {@link #insertButtonView}.
     */
  }, {
    key: "_createInsertButton",
    value: function _createInsertButton() {
      var locale = this.locale;
      var t = locale.t;
      var insertButtonView = new ButtonView(locale);
      insertButtonView.set({
        icon: icons.check,
        class: 'ck-button-save',
        type: 'submit',
        withText: true
      });
      insertButtonView.bind('label').to(this, 'isImageSelected', function (value) {
        return value ? t('Update') : t('Insert');
      });
      insertButtonView.bind('isEnabled').to(this, 'imageURLInputValue', this, 'isEnabled', function () {
        for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
          values[_key] = arguments[_key];
        }
        return values.every(function (value) {
          return value;
        });
      });
      insertButtonView.delegate('execute').to(this, 'submit');
      return insertButtonView;
    }
    /**
     * Creates the {@link #cancelButtonView}.
     */
  }, {
    key: "_createCancelButton",
    value: function _createCancelButton() {
      var locale = this.locale;
      var t = locale.t;
      var cancelButtonView = new ButtonView(locale);
      cancelButtonView.set({
        label: t('Cancel'),
        icon: icons.cancel,
        class: 'ck-button-cancel',
        withText: true
      });
      cancelButtonView.bind('isEnabled').to(this);
      cancelButtonView.delegate('execute').to(this, 'cancel');
      return cancelButtonView;
    }
    /**
     * Focuses the view.
     */
  }, {
    key: "focus",
    value: function focus(direction) {
      if (direction === -1) {
        this.focusCycler.focusLast();
      } else {
        this.focusCycler.focusFirst();
      }
    }
  }]);
  return ImageInsertUrlView;
}(View);
export { ImageInsertUrlView as default };